import type { ClientContactType } from '@econtractor/types';
import type { KeyboardEvent, RefObject } from 'react';
import { Form } from 'react-bootstrap';
import { getContactStartWithFieldProps } from './model/clientContactTypes';
import ContactStartWithField from './ContactStartWithField';

interface ContactValueFieldProps {
    type: ClientContactType;
    value: string;
    disabled?: boolean;
    autoFocus?: boolean;
    inputRef?: RefObject<HTMLInputElement | null>;
    onChange: (value: string) => void;
    onKeyDown?: (event: KeyboardEvent<HTMLInputElement>) => void;
    onBlur?: () => void;
    placeholder?: string;
    size?: 'sm';
}

const ContactValueField = ({
    type,
    value,
    disabled,
    autoFocus,
    inputRef,
    onChange,
    onKeyDown,
    onBlur,
    placeholder,
    size,
}: ContactValueFieldProps) => {
    const fieldProps = getContactStartWithFieldProps(type);
    const controlClassName = size === 'sm' ? 'form-control form-control-sm' : 'form-control';

    if (fieldProps.kind === 'plain') {
        return (
            <Form.Control
                ref={inputRef}
                autoFocus={autoFocus}
                disabled={disabled}
                size={size}
                type={type === 'email' ? 'email' : 'text'}
                value={value}
                placeholder={placeholder}
                onChange={(e) => onChange(e.target.value)}
                onKeyDown={onKeyDown}
                onBlur={onBlur}
            />
        );
    }

    return (
        <ContactStartWithField
            value={value}
            onChange={onChange}
            disabled={disabled}
            autoFocus={autoFocus}
            inputRef={inputRef}
            className={controlClassName}
            startWith={fieldProps.startWith}
            onlyNumber={fieldProps.onlyNumber}
            onKeyDown={onKeyDown}
            onBlur={onBlur}
        />
    );
};

export default ContactValueField;
